// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Amount,
    AmountFromJSON,
    AmountToJSON,
    CreateClaimFacility,
    CreateClaimFacilityFromJSON,
    CreateClaimFacilityToJSON,
    CreateClaimProvider,
    CreateClaimProviderFromJSON,
    CreateClaimProviderToJSON,
    PlaceOfServiceType,
    PlaceOfServiceTypeFromJSON,
    PlaceOfServiceTypeToJSON,
    TemplateDrugInformation,
    TemplateDrugInformationFromJSON,
    TemplateDrugInformationToJSON,
} from './';

/**
 * 
 * @export
 * @interface SupportCreateClaimProfessionalServices
 */
export interface SupportCreateClaimProfessionalServices {
    /**
     * 
     * OpenAPI data type: {PlaceOfServiceType}
     * @type {PlaceOfServiceType}
     * @memberof SupportCreateClaimProfessionalServices
     */
    placeOfService?: PlaceOfServiceType;
    /**
     * The from date of service
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateClaimProfessionalServices
     */
    fromDateOfService?: string;
    /**
     * The through date of service
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportCreateClaimProfessionalServices
     */
    throughDateOfService?: string;
    /**
     * The ICD-10 diagnosis codes used to necessetate the procedure
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof SupportCreateClaimProfessionalServices
     */
    diagnosisCodes?: Array<string>;
    /**
     * The HCPCS procedure code rendered
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateClaimProfessionalServices
     */
    procedureCode?: string;
    /**
     * The procedure modifier codes
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof SupportCreateClaimProfessionalServices
     */
    procedureModifierCodes?: Array<string>;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportCreateClaimProfessionalServices
     */
    chargeAmount?: Amount;
    /**
     * The billable units
     * OpenAPI data type: {number}
     * @type {number}
     * @memberof SupportCreateClaimProfessionalServices
     */
    units?: number;
    /**
     * Professional Only - The service performed was emergent
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportCreateClaimProfessionalServices
     */
    emergency?: boolean;
    /**
     * The service line-level primary payer authorization number.  Use only when different than claim-level value.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateClaimProfessionalServices
     */
    primaryPayerAuthorizationNumber?: string;
    /**
     * The service line-level secondary payer authorization number. Use only when different than claim-level value.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateClaimProfessionalServices
     */
    secondaryPayerAuthorizationNumber?: string;
    /**
     * The service line-level tertiary payer authorization number. Use only when different than claim-level value.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateClaimProfessionalServices
     */
    tertiaryPayerAuthorizationNumber?: string;
    /**
     * Service narrative
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportCreateClaimProfessionalServices
     */
    narrative?: string;
    /**
     * 
     * OpenAPI data type: {TemplateDrugInformation}
     * @type {TemplateDrugInformation}
     * @memberof SupportCreateClaimProfessionalServices
     */
    drug?: TemplateDrugInformation;
    /**
     * 
     * OpenAPI data type: {array}
     * @type {Array<CreateClaimProvider>}
     * @memberof SupportCreateClaimProfessionalServices
     */
    providers?: Array<CreateClaimProvider>;
    /**
     * 
     * OpenAPI data type: {CreateClaimFacility}
     * @type {CreateClaimFacility}
     * @memberof SupportCreateClaimProfessionalServices
     */
    facility?: CreateClaimFacility;
}

export function SupportCreateClaimProfessionalServicesFromJSON(json: any): SupportCreateClaimProfessionalServices {
    return {
            'placeOfService': !exists(json, 'placeOfService') ? undefined : PlaceOfServiceTypeFromJSON(json['placeOfService']),
            'fromDateOfService': !exists(json, 'fromDateOfService') ? undefined : json['fromDateOfService'],
            'throughDateOfService': !exists(json, 'throughDateOfService') ? undefined : json['throughDateOfService'],
            'diagnosisCodes': !exists(json, 'diagnosisCodes') ? undefined : json['diagnosisCodes'],
            'procedureCode': !exists(json, 'procedureCode') ? undefined : json['procedureCode'],
            'procedureModifierCodes': !exists(json, 'procedureModifierCodes') ? undefined : json['procedureModifierCodes'],
            'chargeAmount': !exists(json, 'chargeAmount') ? undefined : AmountFromJSON(json['chargeAmount']),
            'units': !exists(json, 'units') ? undefined : json['units'],
            'emergency': !exists(json, 'emergency') ? undefined : json['emergency'],
            'primaryPayerAuthorizationNumber': !exists(json, 'primaryPayerAuthorizationNumber') ? undefined : json['primaryPayerAuthorizationNumber'],
            'secondaryPayerAuthorizationNumber': !exists(json, 'secondaryPayerAuthorizationNumber') ? undefined : json['secondaryPayerAuthorizationNumber'],
            'tertiaryPayerAuthorizationNumber': !exists(json, 'tertiaryPayerAuthorizationNumber') ? undefined : json['tertiaryPayerAuthorizationNumber'],
            'narrative': !exists(json, 'narrative') ? undefined : json['narrative'],
            'drug': !exists(json, 'drug') ? undefined : TemplateDrugInformationFromJSON(json['drug']),
            'providers': !exists(json, 'providers') ? undefined : (json['providers'] as Array<any>).map(CreateClaimProviderFromJSON),
            'facility': !exists(json, 'facility') ? undefined : CreateClaimFacilityFromJSON(json['facility']),
    };

}

export function SupportCreateClaimProfessionalServicesToForm(value?: SupportCreateClaimProfessionalServices): any {
    let jsonVal = SupportCreateClaimProfessionalServicesToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function SupportCreateClaimProfessionalServicesToJSON(value?: SupportCreateClaimProfessionalServices): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'placeOfService': PlaceOfServiceTypeToJSON(value.placeOfService),
            'fromDateOfService': cleanupBlankValuesForBackend(value.fromDateOfService),
            'throughDateOfService': cleanupBlankValuesForBackend(value.throughDateOfService),
            'diagnosisCodes': cleanupBlankValuesForBackend(value.diagnosisCodes),
            'procedureCode': cleanupBlankValuesForBackend(value.procedureCode),
            'procedureModifierCodes': cleanupBlankValuesForBackend(value.procedureModifierCodes),
            'chargeAmount': AmountToJSON(value.chargeAmount),
            'units': cleanupBlankValuesForBackend(value.units),
            'emergency': cleanupBlankValuesForBackend(value.emergency),
            'primaryPayerAuthorizationNumber': cleanupBlankValuesForBackend(value.primaryPayerAuthorizationNumber),
            'secondaryPayerAuthorizationNumber': cleanupBlankValuesForBackend(value.secondaryPayerAuthorizationNumber),
            'tertiaryPayerAuthorizationNumber': cleanupBlankValuesForBackend(value.tertiaryPayerAuthorizationNumber),
            'narrative': cleanupBlankValuesForBackend(value.narrative),
            'drug': TemplateDrugInformationToJSON(value.drug),
            'providers': (value.providers === undefined || value.providers === null) ? undefined : (value.providers as Array<any>).map(CreateClaimProviderToJSON),
            'facility': CreateClaimFacilityToJSON(value.facility),
    };
}


